import { CmsComponentProps } from '@/types/cms';
import classNames from 'classnames';
import { FC } from 'react';
import useClickActionT2 from '@/tracks/useClickActionT2';
import Size from '../../types/size';
import { twMerge } from 'tailwind-merge';
import { handleCmsJump } from '../../tools/cms-link';
import { useRouter } from 'next/router';

const Button: FC<CmsComponentProps> = props => {
  const router = useRouter();
  const { cmsComponentKey, properties, componentPos, trackingContext } = props;
  const { buttonClickExtraParams } = useClickActionT2();

  const handleBtn = e => {
    buttonClickExtraParams({
      mod_nm: properties?.event_key || cmsComponentKey,
      mod_pos: componentPos,
      co: {
        url: properties?.link_url
      },
      ctx: trackingContext
    });
    e.stopPropagation();
    let linkUrl = properties?.link_url;
    if (linkUrl) {
      handleCmsJump(linkUrl, router);
    }
  };

  return (
    <div
      data-module={props.cmsComponentKey}
      className={twMerge(
        classNames('mx-0 my-2.5 px-3 py-0', {
          'my-2.5': properties?.vertical_margin === Size.small,
          'my-5': properties?.vertical_margin === Size.middle,
          'my-10': properties?.vertical_margin === Size.large
        })
      )}>
      <button
        onClick={handleBtn}
        className={twMerge(
          classNames(
            'flex justify-center items-center w-[unset] max-w-full min-w-[73px] min-h-[40px] text-base leading-[130%] font-semibold tracking-[-0.32px] mx-auto my-0 px-[15px] py-2 rounded-[100px] border-[none]',
            {
              'text-reserved-true-white bg-primary-2': properties?.button_style === 'style_1',
              'text-reserved-true-white bg-reserved-true-black': properties?.button_style === 'style_2',
              'text-surface-100-fg-default bg-surface-100-bg border border-solid border-surface-100-hairline':
                properties?.button_style === 'style_3'
            }
          )
        )}>
        <span className="truncate">{properties?.text}</span>
      </button>
    </div>
  );
};

export default Button;
